import { Box, Stack, TextField, Typography } from "@mui/material"

interface DateRangeFilterProps {
  label?: string
  startDate: string
  endDate: string
  onStartDateChange: (value: string) => void
  onEndDateChange: (value: string) => void
  required?: boolean
}

export function DateRangeFilter({
  label = "Date Range",
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  required = false,
}: DateRangeFilterProps) {
  return (
    <Box>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
        {label}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          label="From"
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          size="small"
          InputLabelProps={{ shrink: true }}
          required={required}
          sx={{ minWidth: 160 }}
        />
        <Typography variant="body2" color="textSecondary">
          to
        </Typography>
        <TextField
          label="To"
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          size="small"
          InputLabelProps={{ shrink: true }}
          required={required}
          sx={{ minWidth: 160 }}
        />
      </Stack>
    </Box>
  )
}
